import { createContext } from 'react';

interface ShoppingCartContext {
	/** Stripe works with prices more than products. At checkout time we pass a list of price IDs with quantity */
	quantityPerPriceItemId: Map<string, number>;
	totalItemsInCart: number;
	setQuantity: (id: string | undefined, quantity: number) => void;
	clearCart: () => void;
}

export const ShoppingCartContext = createContext<ShoppingCartContext>({
	quantityPerPriceItemId: new Map(),
	totalItemsInCart: 0,
	setQuantity: () => {},
	clearCart: () => {},
});
